module.exports = __webpack_public_path__ + "img/blueBin.5bf14f14.svg";